import moment from 'moment';
import { useCallback } from 'react';
import { Entity } from '@shared/data/entity/Entity';
import { isDateField } from '@shared/data/entity/fields/DateField';
import { PRICING_LIMIT_HISTORY_DAYS } from '@shared/styles';
import { useCanViewCollectionView } from './useCanViewCollectionView';

export type IsCardBeforePaidCutoffHandler = (card: Entity) => boolean;

export function useIsCardBeforePaidCutoff(): IsCardBeforePaidCutoffHandler {
  const isPaid = useCanViewCollectionView();

  return useCallback(
    (card: Entity) => {
      if (isPaid) {
        return false;
      }
      const createdAtField = card.allFields.get('createdAt');
      if (!isDateField(createdAtField)) {
        return false;
      }
      const isCardBeforePaidCutoff = moment(createdAtField.date).isSameOrBefore(
        moment().subtract(PRICING_LIMIT_HISTORY_DAYS, 'd'),
      );
      return isCardBeforePaidCutoff;
    },
    [isPaid],
  );
}
